import React from 'react';
import { string, node, arrayOf, oneOfType, bool, element } from 'prop-types';
import { CondensedMedium, Flashy, Layout } from '@axiom/ui';

import { formatDataTestId } from '../../utils/data-test-util';

import {
  UnorderedListWrapper,
  ULAftIcon,
  ULTitle,
  List,
} from './UnorderedListStyles';

const PLACEHOLDER = '--';

const getMixedValue = values =>
  (typeof values === 'string' && values.trim().length > 0) ||
  typeof values === 'number' ||
  React.isValidElement(values)
    ? values
    : PLACEHOLDER;

const UnorderedList = ({
  showAftIcon,
  dataValue,
  values,
  title,
  className,
  showBullets,
  footNote,
  dataTestId,
  candidateStatus,
  tooltip,
}) => (
  <UnorderedListWrapper className={className}>
    <Layout position="space-between middle">
      <ULTitle candidateStatus={candidateStatus}>
        {title}
        {!!showAftIcon && <ULAftIcon />}
      </ULTitle>
      {!!tooltip && tooltip}
    </Layout>
    <List showBullets={showBullets}>
      {Array.isArray(values) && values.length > 0 ? (
        values.map((value, index) => (
          <li
            key={`${value}.${index.toString()}`}
            data-test={formatDataTestId(dataTestId || title || 'display value')}
            data-value={dataValue}
          >
            {getMixedValue(value)}
          </li>
        ))
      ) : (
        <li
          data-test={formatDataTestId(dataTestId || title || 'display value')}
          data-value={dataValue}
        >
          {getMixedValue(values)}
        </li>
      )}
    </List>
    {!!footNote && (
      <CondensedMedium name="FOOTER_NOTE">
        <Flashy italic>{footNote}</Flashy>
      </CondensedMedium>
    )}
  </UnorderedListWrapper>
);

UnorderedList.defaultProps = {
  showAftIcon: false,
  className: null,
  showBullets: false,
  footNote: null,
  values: undefined,
  dataValue: null,
  dataTestId: null,
  candidateStatus: undefined,
  tooltip: null,
};

UnorderedList.propTypes = {
  candidateStatus: string,
  className: string,
  dataTestId: string,
  dataValue: string,
  footNote: string,
  showAftIcon: bool,
  showBullets: bool,
  title: oneOfType([string, element]).isRequired,
  tooltip: node,
  values: oneOfType([arrayOf(node), node]),
};

export default UnorderedList;
